/*!

*/
import React , {useEffect, useState}from "react";
// react plugin used to create charts
import { Line, Bar, Doughnut } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import {  useLocation ,useNavigate , useHistory} from 'react-router-dom';
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import {customStyles} from '../../../helpers/mycomps'
import DatePicker from "react-datepicker";


const months = [
  {value : 0, label : "Jan"},
  {value : 1, label : "Feb"},
  {value : 2, label : "Mar"},
  {value : 3, label : "April"},
  {value : 4, label : "May"},
  {value : 5, label : "June"},
  {value : 6, label : "July"},
  {value : 7, label : "Aug"},
  {value : 8, label : "Sept"},
  {value : 9, label : "Oct"},
  {value : 10, label : "Nov"},
  {value : 11, label : "Dec"}
]

function Dashboard(props) {
  let d = new Date()
  d.setDate(d.getDate() - 7);
  const [counts, setCounts] = useState({tcount : "0", vcount : "0", ucount : "0", dcount: "0", fcount: "0", pcount: "0"})
  const [catcounts, setCatcounts] = useState({road : "0", machines : "0", yachts : "0"})
  const [showProcessing , setShowProcessing] = useState(false)
  const [month , setMonth] = useState({value : d.getMonth() , label : d.toLocaleString('default', { month: 'short' })})
  var history = useHistory()

  var opts = {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },

    scales: {
      y: {
        ticks: {
          color: "#9f9f9f",
          beginAtZero: false,
          maxTicksLimit: 5,
          //padding: 20
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          padding: 20,
          color: "#9f9f9f",
        },
      },
    },
  }

  const [carsChart, setCarsChart] = useState({
    data: {
      labels: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      datasets: [
        {
          label: "Active Users",
          borderColor: "#6bd098",
          pointRadius: 0,
          pointHoverRadius: 0,
          fill: false,
          borderWidth: 3,
          barPercentage: 1.6,
          tension: 0.4,
          data: [542, 480, 430, 550, 530, 2453, 380, 434, 568, 610,542, 480, 430, 550, 530, 453, 380, 434, 568, 1610,542, 480, 430, 550, 530, 453, 380, 434, 568, 610],
        },
      ],
    }
  })

  const [yachtsChart, setYachtsChart] = useState({
    data: {
      labels: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      datasets: [
        {
          label: "Active Users",
          borderColor: "#6bd098",
          pointRadius: 0,
          pointHoverRadius: 0,
          fill: false,
          borderWidth: 3,
          barPercentage: 1.6,
          tension: 0.4,
          data: [542, 480, 430, 550, 530, 2453, 380, 434, 568, 610,542, 480, 430, 550, 530, 453, 380, 434, 568, 1610,542, 480, 430, 550, 530, 453, 380, 434, 568, 610],
        },
      ],
    }
  })

  const [machinesChart, setMachinesChart] = useState({
    data: {
      labels: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      datasets: [
        {
          label: "Active Users",
          borderColor: "#6bd098",
          pointRadius: 0,
          pointHoverRadius: 0,
          fill: false,
          borderWidth: 3,
          barPercentage: 1.6,
          tension: 0.4,
          data: [542, 480, 430, 550, 530, 2453, 380, 434, 568, 610,542, 480, 430, 550, 530, 453, 380, 434, 568, 1610,542, 480, 430, 550, 530, 453, 380, 434, 568, 610],
        },
      ],
    }
  })

  const [carsChartc, setCarsChartc] = useState(0)
  const [yachtsChartc, setYachtsChartc] = useState(0)
  const [machinesChartc, setMachinesChartc] = useState(0)

  const [date1, setDate1] = useState(new Date())
  const [date2, setDate2] = useState(new Date())

  useEffect(() => {
    getchart()
    getstats()
  },[])  
  
  useEffect(() => {
    getchart()
    
  },[month])  

  const getstats = () => {
    props.API.get(`tenant/getdbdata`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}})
      .then((res) => {
   
      setCounts({
        
        tcount : res.data.tcount,
        vcount : res.data.vcount,
        ucount : res.data.ucount,
        pcount : res.data.lcount.clistp,
        fcount : res.data.lcount.clistf,
        dcount : res.data.lcount.clistd
      })
      setCatcounts({
        road : res.data.road,
        machines : res.data.machines,
        yachts : res.data.yachts,
         })

    }).catch(function (error) {
      localStorage.setItem('arixauth', "") 
      history.push('/auth/login')
        console.log(error)

        //props.basicAlert("Invalid Login")
    }) 
  }

  const getchart = () => {
    props.API.get(`/tenant/dblccat/${month.value}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      
      
        let clabels = res.data.cars.map(x => x._id)
        let cdata = res.data.cars.map(x => x.count)
        let cdatasets = [
          {
            label: "Active Users",
            borderColor: "#6bd098",
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            borderWidth: 3,
            barPercentage: 1.6,
            tension: 0.4,
            data: cdata,
          }]
        setCarsChart({data : {labels : clabels, datasets : cdatasets}})
        setCarsChartc(cdata.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0))

        let ylabels = res.data.yachts.map(x => x._id)
        let ydata = res.data.yachts.map(x => x.count)
        let ydatasets = [
          {
            label: "Active Users",
            borderColor: "#6bd098",
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            borderWidth: 3,
            barPercentage: 1.6,
            tension: 0.4,
            data: ydata,
          }]
        setYachtsChart({data : {labels : ylabels, datasets : ydatasets}})
        setYachtsChartc(ydata.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0))
        
        let mlabels = res.data.machines.map(x => x._id)
        let mdata = res.data.machines.map(x => x.count)
        let mdatasets = [
          {
            label: "Active Users",
            borderColor: "#6bd098",
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            borderWidth: 3,
            barPercentage: 1.6,
            tension: 0.4,
            data: mdata,
          }]
        setMachinesChart({data : {labels : mlabels, datasets : mdatasets}})
        setMachinesChartc(mdata.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0))
          
      
     }).catch(function (error) {
       console.log(error)
       setShowProcessing(false)
       
       if(error.response.status === 401){
         props.swal("Unauthorized, please login again.").then(t => {
             props.history.push(`/auth/login`)
         })   
       }       
     }) 
     setShowProcessing(false)
  }


var reportr1 = { t_id : "t_id", 
name : "name" , email : "email" ,cell : "cell" , 
listing_type : "listing_type" , category :"category" , 
cat_name : "cat_name" , Details : "Details" , WA : "WA" , 
Callc : "Callc" , Enq : "Enq" , 
Total_listings : "Total_listings"}         

var reportr2 = { 
  ate_time : "date_time" , click_id : "click_id" , user : "user" , user_name  :"user_name" 
  , user_phone : "user_phone" , user_email  : "user_email", tenant_id : "tenant_id" , listing_id : "listing_id" 
  , tenant_name : "tenant_name" , tenant_cellNumber : "tenant_cellNumber" , tenant_emailid : "tenant_emailid" , brand : "brand" 
  , model : "model" , type  : "type"

} 

var reportr3 = { 
  t_id : "t_id" ,
  t_name  : "t_name" ,
  type : "type" , 
  t_email : "t_email" , 
  contact  : "contact", 
  brand  :"brand" ,
  model : "model", 
  vtype : "vtype", 
  listing_status : "listing_status", 
  create_date : "create_date" , 
  update_date : "update_date"

} 


  function convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
}

function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
      items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }
}

  const repdata = (date1, date2, report) => {
    let headersname = ""
    if(report === "reportr1" ){
         headersname = reportr1
    }else if(report === "reportr2") {
          headersname = reportr2
    }else if(report === "reportr3") {
          headersname = reportr3
    } 
    else{
      return
    } 
    setShowProcessing(true)
    props.API.get(`/${report}/${date1}/${date2}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}})
    .then((res) => {
        console.log(res.data.csvx)

        exportCSVFile(headersname ,res.data.csvx, report + "_" + new Date(date1).toDateString("en-GB") + "_" + new Date(date2).toDateString("en-GB") )
        setShowProcessing(false)
    
   }).catch(function (error) {
    try{
      console.log(error)
      if(error.response.status === 401){
       props.swal("Unauthorized, please login again.").then(t => {
           props.history.push(`/auth/login`)
       })   
     }
      setShowProcessing(false)
    }catch(e){
      setShowProcessing(false)
    }
   }) 
  }


  return (
    <>
      <div className="content">
        {showProcessing && props.Spin}
        <Row>
          <Col>
            <Card>
              <b>Reports</b>
              <CardBody>
                    <Row>
                     <Col style={{paddingRight : 0, marginRight : 0}}>From <DatePicker selected={date1} onChange={(date) => setDate1(date)} maxDate={date2} /></Col>
                                        <Col> To <DatePicker selected={date2} onChange={(date) => setDate2(date)} minDate={date1} /></Col>
                     <Col style={{paddingRight : 0, marginRight : 0}}> 
                        <Button style={{marginTop : -6}} size="sm" onClick={f => repdata( date1, date2, "reportr1")}>R1 <i class="fa fa-download" aria-hidden="true"></i></Button>
                        <Button style={{marginTop : -6}} size="sm" onClick={f => repdata( date1, date2, "reportr2")}>R2 <i class="fa fa-download" aria-hidden="true"></i></Button>
                        <Button style={{marginTop : -6}} size="sm" onClick={f => repdata( date1, date2, "reportr3")}>R3 <i class="fa fa-download" aria-hidden="true"></i></Button> 
                     </Col>
                     </Row>
                    
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
        <Col lg="2" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-vector text-danger" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Total Models</p>
                      <CardTitle tag="p">{counts.vcount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-clock-o" onClick={h => getstats()}/>
                  Update Now
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="2" md="6" sm="6">
            <Card className="card-stats" >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-money-coins text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Total Listings</p>
                      <CardTitle tag="p" style={{fontSize : "1.3rem"}}>{counts.pcount} / {counts.fcount} / {counts.dcount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats" style={{fontSize : "0.7rem"}}>
                  <i className="fa fa-calendar-o" onClick={h => getstats()} />
                  Premium / Featured / Delisted
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="2" md="6" sm="6">
            <Card className="card-stats" >
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-money-coins text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Listings</p>
                      <CardTitle tag="p" style={{fontSize : "1.3rem"}}>{catcounts.road} / {catcounts.machines} / {catcounts.yachts}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats" style={{fontSize : "0.7rem"}}>
                  <i className="fa fa-calendar-o" onClick={h => getstats()} />
                  Vehicles / Machines / Yacht
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="2" md="6" sm="6"></Col>
          
          <Col lg="2" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-globe text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Users</p>
                      <CardTitle tag="p">{counts.ucount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()} />
                  Update Now
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="2" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-favourite-28 text-primary" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Tenants</p>
                      <CardTitle tag="p">{counts.tcount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()}/>
                  Update now
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>


        <Row style={{marginBottom : 15, marginTop : -5}}>
                        <Col> <span style={{float : "right", marginTop : 10, fontWeight : "bold"}}>Graph for :</span></Col>
                        <Col md="2"> 
                                    <Select options={months} styles={customStyles} className={"shadow"}
                                      onChange={e=> {setMonth(e)}} value={month}  />
                        </Col>
            </Row>
        <Row>

          <Col lg="4" sm="6">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="7">
                    <div className="numbers pull-left">{carsChartc}</div>
                  </Col>
                  <Col sm="5">
                    <div className="pull-right">
                      <Badge color="success" pill style={{fontSize : "1em"}}>
                      {month.label}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <h6 className="big-title">
                  Cars Clicks 
                </h6>
                <Line
                  data={carsChart.data}
                  options={opts}
                  height={380}
                  width={826}
                />
              </CardBody>
              <CardFooter>
                <hr />
               
              </CardFooter>
            </Card>
          </Col>
          <Col lg="4" sm="6">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="7">
                    <div className="numbers pull-left">{yachtsChartc}</div>
                  </Col>
                  <Col sm="5">
                    <div className="pull-right">
                      <Badge color="danger" pill style={{fontSize : "1em"}}>
                        {month.label}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <h6 className="big-title">
                  Yacht Clicks
                </h6>
                <Line
                  data={yachtsChart.data}
                  options={opts}
                  height={380}
                  width={828}
                />
              </CardBody>
              <CardFooter>
                <hr />
             
              </CardFooter>
            </Card>
          </Col>
          <Col lg="4" sm="6">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="7">
                    <div className="numbers pull-left">{machinesChartc}</div>
                  </Col>
                  <Col sm="5">
                    <div className="pull-right">
                      <Badge color="warning" pill style={{fontSize : "1em"}}>
                      {month.label}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <h6 className="big-title">Machines Clicks</h6>
                <Line
                  data={machinesChart.data}
                  options={opts}
                  height={380}
                  width={826}
                />
              </CardBody>
              <CardFooter>
                <hr />
               
              </CardFooter>
            </Card>
          </Col>
        </Row>
     
      
      </div>
    </>
  );
}

export default Dashboard;
